import * as React from "react"
import type { SVGProps } from "react"
const SvgLineChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20.8 9.97a1 1 0 0 1-.2 1.4l-5.33 4a1 1 0 0 1-1.2 0l-4.74-3.55-4.73 3.55a1 1 0 1 1-1.2-1.6l5.33-4a1 1 0 0 1 1.2 0l4.74 3.55 4.73-3.55a1 1 0 0 1 1.4.2" />
  </svg>
)
export default SvgLineChart
